<template>
    <!--FORGOT PASSWORD-->
    <ThePageExternal :title="'FORGOT_PASSWORD__RESET_PASSWORD'"
                     :class-name="'ForgotPasswordView'">

        <!--EMAIL WAS SENT-->
        <template v-if="completedSuccessfully">
            <div class="ForgotPasswordView__text">
                {{translate('FORGOT_PASSWORD__EMAIL_WAS_SENT')}}
            </div>
            <div class="ForgotPasswordView__actions">
                <BaseButtonFlat v-bind:label="'FORGOT_PASSWORD__BACK_TO_SIGN_IN'"
                             v-bind:class-name="'ForgotPasswordView__signin'"
                             @click="openSignIn()" />
            </div>
        </template>

        <!--FORGOT PASSWORD FORM-->
        <template v-else>
            <div class="ForgotPasswordView__text">
                {{translate('FORGOT_PASSWORD__ENTER_EMAIL')}}
            </div>
            <!--EMAIL-->
            <BaseText :label="'FORGOT_PASSWORD__EMAIL'"
                      :value="email"
                      :errors="errors['email']"
                      :autofocus="true"
                      :icon="'icon-mail'"
                      @change="setEmail($event.target.value)" />
            <div class="ForgotPasswordView__actions">

                <!--BACK TO SIGN IN-->
                <BaseButtonFlat v-bind:label="'FORGOT_PASSWORD__BACK_TO_SIGN_IN'"
                                v-bind:class-name="'ForgotPasswordView__signin'"
                                @click="openSignIn()" />

                <!--SEND-->
                <BaseButton v-bind:label="'FORGOT_PASSWORD__SEND'"
                            @click="send($event.target)" />
            </div>
        </template>
    </ThePageExternal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ThePageExternal from '../components/common/ThePageExternal.vue';
    import BaseText from '../components/common/BaseText.vue';
    import BaseButton from '../components/common/BaseButton.vue';
    import BaseButtonFlat from '../components/common/BaseButtonFlat.vue';

    export default {
        name: 'ForgotPasswordView',
        components: {
            ThePageExternal,
            BaseText,
            BaseButton,
            BaseButtonFlat
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.load();
            })
        },
        computed: {
            ...mapState({
                completedSuccessfully: s => s.forgotPassword.completedSuccessfully,
                email: s => s.forgotPassword.email,
                errors: s => s.forgotPassword.errors
            })
        },
        methods: {
            ...mapActions({
                load: 'forgotPassword/load',
                openSignIn: 'forgotPassword/openSignIn',
                send: 'forgotPassword/send',

                //Setters
                setEmail: 'forgotPassword/setEmail'
            })
        }
    };
</script>

<style>
    .ForgotPasswordView {
        width: 360px;
        max-height: 282px;
    }

    .ForgotPasswordView__text {
        padding-bottom: 10px;
        color: #607D8B;
    }

    .ForgotPasswordView__actions {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 20px 0;
    }

    .ForgotPasswordView__signin {
        font-size: 12px;
        margin-right: 16px;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// ForgotPasswordView.vue?67c00c54